import { render, staticRenderFns } from "./tree.vue?vue&type=template&id=28d03b96&"
import script from "./tree.vue?vue&type=script&lang=js&"
export * from "./tree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports